import usePermission from 'hooks/usePermission';

const capitalizeFirstLetter = (str) => {
    if (!str || typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const formatPatientNameCore = (nameFields, patientNameOrder = null, fieldMapping = null) => {
    const defaultFieldMapping = {
        firstName: 'first_name',
        middleName: 'middle_name',
        lastName: 'last_name'
    };

    const mapping = fieldMapping || defaultFieldMapping;

    const defaultOrder = ['first_name', 'middle_name', 'last_name'];
    const configOrder = patientNameOrder?.order || defaultOrder;

    const actualOrder = configOrder.map((field) => {
        if (field === 'first_name') return mapping.firstName;
        if (field === 'middle_name') return mapping.middleName;
        if (field === 'last_name') return mapping.lastName;
        return field;
    });

    const startsWithLastName = configOrder[0] === 'last_name';

    if (startsWithLastName) {
        const lastNameField = actualOrder[0];
        const firstNameField = actualOrder[1];
        const middleNameField = actualOrder[2];

        const lastName = capitalizeFirstLetter(nameFields?.[lastNameField] || '');
        const firstName = capitalizeFirstLetter(nameFields?.[firstNameField] || '');
        const middleName = capitalizeFirstLetter(nameFields?.[middleNameField] || '');

        if (lastName.trim()) {
            const remaining = [firstName, middleName].filter((v) => v.trim()).join(' ');
            return remaining ? `${lastName}, ${remaining}` : lastName;
        }

        return [firstName, middleName].filter((v) => v.trim()).join(' ');
    }

    const names = actualOrder.map((field) => capitalizeFirstLetter(nameFields?.[field] || '')).filter((value) => value.trim() !== '');

    return names.join(' ');
};

export const usePatientNameOrderValueGetter = (fieldMapping = null) => {
    const { patientNameOrder } = usePermission();

    return (nameFields) => formatPatientNameCore(nameFields, patientNameOrder, fieldMapping);
};

export const formatPatientName = (nameFields, fieldMapping = null) => {
    const defaultFieldMapping = {
        firstName: 'first_name',
        middleName: 'middle_name',
        lastName: 'last_name'
    };

    const mapping = fieldMapping || defaultFieldMapping;

    const configOrder = ['first_name', 'middle_name', 'last_name'];

    const actualOrder = configOrder.map((field) => {
        if (field === 'first_name') return mapping.firstName;
        if (field === 'middle_name') return mapping.middleName;
        if (field === 'last_name') return mapping.lastName;
        return field;
    });

    const names = actualOrder.map((field) => capitalizeFirstLetter(nameFields?.[field] || '')).filter((value) => value.trim() !== '');

    return names.join(' ');
};
